/**
 * Onboarding tour + contextual hints — shared constants (v3.75.0).
 *
 * Everything the tour persists is keyed by TOUR_VERSION: bump it when the
 * tour changes enough that returning teachers should see it again. Seeds
 * (harness + demo login) write `onboarding.tourVersion = TOUR_VERSION` so
 * seeded users never auto-start it.
 */

export const TOUR_VERSION = 1;

/** data-tour attribute values — the ONLY selectors the tour and hints use. */
export const TOUR_TARGETS = Object.freeze({
  classFilter: 'dashboard-class-filter',
  bandSummary: 'dashboard-band-summary',
  navLetterSound: 'nav-group-letter-sound',
  navManagement: 'nav-group-management',
  navHelp: 'nav-group-help',
  assessControls: 'assess-response-controls',
  resultsFirstTable: 'results-first-table',
});

export const HINT_KEYS = Object.freeze({
  assessLetterSound: 'assessLetterSound',
  results: 'results',
});

/** Screen keys pages report readiness under (useOnboardingScreen). */
export const SCREEN_DASHBOARD = 'dashboard';

/** Auto-start needs at least this many steps with a present target. */
export const MIN_TARGETED_STEPS = 3;

/** Wait after readiness (plus one frame) so the dashboard is visible first. */
export const START_DELAY_MS = 300;

/** How long a step waits for its target to settle after nav choreography. */
export const TARGET_SETTLE_TIMEOUT_MS = 1500;

/** Demo surface: seen-state lives in sessionStorage, never Firestore. */
export const DEMO_STORAGE_KEY = 'literacy-app:onboarding:v1';

/** Body class while a tour or hint is driving the nav (transitions off). */
export const BODY_ACTIVE_CLASS = 'onboarding-tour-active';

/** Sidebar group names the tour opens (must match App.js navItems groups). */
export const NAV_GROUP_LETTER_SOUND = 'Letter/Sound';
export const NAV_GROUP_MANAGEMENT = 'Management';
export const NAV_GROUP_HELP = 'Help';

/** The sidebar drawer overlays content at and below this width (App.js). */
export const PHONE_MAX_WIDTH = 768;

export const SUPPORT_EMAIL = 'support@literacyassessments.com';
export const TEACHER_DASHBOARD_PATH = '/dashboard';

/** helpVideos entry id the last tour step offers when enabled. */
export const FIRST_ASSESSMENT_VIDEO_ID = 'first-assessment';
